import type { RepositoryIndexingMode } from "@arti/shared-source-control/indexing/runMode";
import type { FC } from "react";

import { IndexingModeSelector } from "./IndexingModeSelector";

interface IndexingRunRepositoryRowProps {
  checked: boolean;
  disabled: boolean;
  mode: RepositoryIndexingMode;
  repositorySlug: string;
  onCheckedChange: (checked: boolean) => void;
  onModeChange: (mode: RepositoryIndexingMode) => void;
}

export const IndexingRunRepositoryRow: FC<IndexingRunRepositoryRowProps> = ({
  checked,
  disabled,
  mode,
  repositorySlug,
  onCheckedChange,
  onModeChange,
}) => (
  <li className="grid gap-3 bg-white px-3 py-3 dark:bg-arti-background md:grid-cols-[minmax(0,1fr),auto]">
    <label className="flex min-w-0 items-start gap-3">
      <input
        type="checkbox"
        className="mt-1 h-4 w-4 rounded-none border-slate-300 text-emerald-600 focus:ring-emerald-500 dark:border-slate-600 dark:bg-slate-900"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onCheckedChange(event.currentTarget.checked)}
      />
      <div className="min-w-0">
        <div className="truncate font-mono text-[11px] font-bold uppercase tracking-[0.18em] text-slate-800 dark:text-slate-100">
          {repositorySlug}
        </div>
        <div className="mt-1 text-xs text-slate-500 dark:text-slate-400">
          {checked ? "Included in this run." : "Excluded from this run."}
        </div>
      </div>
    </label>

    <div className="flex items-center">
      <IndexingModeSelector
        disabled={disabled || !checked}
        mode={mode}
        onChange={onModeChange}
      />
    </div>
  </li>
);
